module.exports = __webpack_public_path__ + "static/media/Airport.c3b58349.jpg";